/**
 * `hotdesk` translations, for every locale.
 *
 * The `legend*` keys name the seven states a desk can be in ACROSS THE WHOLE
 * SELECTION, not on one day — see `deskState` in pages/hotdesk/HotDesk.tsx. The
 * plan's accessible label reads the same key the legend prints, so a desk never
 * says one thing to a screen reader and another to the eye.
 */
export const hotdesk = {
  mn: {
      hotdesk: {
        blocked: { pending: 'Хадгалж байна…', noDays: 'Хуанлиас боломжтой өдөр сонгоно уу', deskOut: 'Энэ ширээ ашиглалтаас гарсан', noHalf: 'Өглөө эсвэл орой гэснийг сонгоно уу', bothHeld: 'Өдөр бүхэлдээ өөр хүнд захиалагдсан', nameEmpty: 'Ширээний нэрийг бичнэ үү' },
        desksLoadFailed: 'Ширээнүүдийг ачаалж чадсангүй.', bookingsLoadFailed: 'Захиалгуудыг ачаалж чадсангүй.',
        plan: 'Оффисын зураглал', desk: 'Ширээ', free: 'Сул', someone: 'Хэн нэгэн',
        reservations: 'Захиалгууд', none: 'Захиалга алга',
        colWho: 'Хэн', searchWho: 'Нэрээр хайх', noMatch: 'Тохирох захиалга алга',
        book: 'Захиалах', release: 'Цуцлах',
        bookAvailable: 'Сул өдрүүдийг захиалах ({{days}})',
        allDay: 'Бүтэн өдөр', morning: 'Өглөө', afternoon: 'Үдээс хойш',
        purpose: 'Төрөл', flexible: 'Уян хатан', inflexible: 'Тогтмол',
        forVisitor: 'Зочны нэрээр', visitorName: 'Зочны нэр',
        booked: 'Захиаллаа', released: 'Цуцаллаа', moveDesks: 'Ширээ зөөх', saveLayout: 'Байршил хадгалах',
        layoutSaved: 'Байршил хадгалагдлаа', changePlan: 'Зураглал солих', planReplaced: 'Зураглал солигдлоо',
        planFailed: 'Зураглалын зургийг ачаалж чадсангүй: {{detail}}',
        dragHint: 'Ширээг чирж байрлуулна уу',
        // Desk add/rename (673) and change of service (677) — never delete,
        // see office router
        addDesk: 'Ширээ нэмэх', addDeskTitle: 'Шинэ ширээ нэмэх',
        rename: 'Нэр өөрчлөх', renameDeskTitle: '«{{desk}}» ширээний нэрийг өөрчлөх',
        deskName: 'Ширээний нэр',
        deskAdded: 'Ширээ нэмэгдлээ', deskRenamed: 'Ширээний нэр өөрчлөгдлөө',
        deskNameTooLong: 'Ширээний нэр 50 тэмдэгтээс ихгүй байх ёстой',
        deskNameDuplicate: 'Ийм нэртэй ширээ бий болсон байна',
        suspendDesk: 'Ашиглалтаас гаргах', restoreDesk: 'Ашиглалтад буцаах',
        suspendTitle: '«{{desk}}» ширээг ашиглалтаас гаргах уу?',
        suspendExplain:
          'Хэн ч захиалж чадахгүй бөгөөд зураглал дээр бүдэг харагдана. Юу ч устгахгүй — хүссэн үедээ ашиглалтад буцаана.',
        suspendKeepsBookings: 'Өмнө хийсэн захиалгууд хэвээр үлдэнэ.',
        suspendNoUpcoming: 'Өнөөдрөөс хойш захиалга алга.',
        suspendUpcoming:
          'Өнөөдрөөс хойшх захиалга: {{count}}. Эдгээр хэвээр үлдэх боловч ашиглалтад буцаах хүртэл дахин захиалах боломжгүй.',
        deskSuspended: 'Ширээг ашиглалтаас гаргалаа', deskRestored: 'Ширээг ашиглалтад буцаалаа',
        // Calendar
        prevMonth: 'Өмнөх сар', nextMonth: 'Дараах сар',
        dowMon: 'Да', dowTue: 'Мя', dowWed: 'Лх', dowThu: 'Пү', dowFri: 'Ба', dowSat: 'Бя', dowSun: 'Ня',
        holidayIs: 'Амралтын өдөр: {{title}}', onLeave: 'Та чөлөөтэй',
        yourDeskIs: 'Таны ширээ: {{desk}}',
        pickWeekHint: 'Нэг долоо хоногийн дотор хэдэн ч өдөр сонгож болно. Түүхийг харахын тулд өнгөрсөн өдрийг сонгоорой; захиалга зөвхөн өнөөдрөөс эхэлнэ.',
        pickDaysFirst: 'Хуанлиас өдрөө сонгоно уу', pickDesk: 'Зураглалаас ширээ сонгоно уу',
        past: 'Өнгөрсөн', today: 'өнөөдөр',
        freeOnSelection: '{{total}}-аас {{free}} ширээ сул',
        // Desk panel
        outOfService: 'Ашиглалтгүй', noKit: 'Тоног төхөөрөмж бүртгэгдээгүй',
        halfTaken: 'Өөр хүний эзэмшсэн хагасыг захиалах боломжгүй.',
        capReached: 'Та {{desk}} ширээг өнгөрсөн долоо хоногт {{times}} удаа захиалсан тул энэ долоо хоногт боломжгүй байж магадгүй.',
        capExempt: 'Та {{desk}} ширээг өнгөрсөн долоо хоногт {{times}} удаа захиалсан. Та долоо хоног тутмын хязгаараас чөлөөлөгдсөн тул энэ нь таны захиалгыг хаахгүй.',
        willReplace: 'Захиалахад дараах захиалга цуцлагдана: {{list}} — нэг хүн өдөрт нэг ширээ.',
        // Legend
        legendNone: 'Өдөр сонговол сул эсэхийг харуулна', legendFree: 'Бүх өдөрт сул',
        legendMine: 'Таны захиалга, бүх өдөрт', legendMineSome: 'Таны захиалга, зарим өдөрт',
        legendInflexible: 'Тогтмол захиалга', legendFlexible: 'Уян хатан, бүтэн өдөр',
        legendHalf: 'Хагас өдөр', legendMixed: 'Холимог',
        legendSelected: 'Сонгосон', legendInactive: 'Ашиглалтгүй',
        legendCapped: 'Танд хаагдсан байж магадгүй',
      },
  },
  en: {
      hotdesk: {
        blocked: { pending: 'Working…', noDays: 'Pick a bookable day on the calendar first', deskOut: 'This desk is out of service', noHalf: 'Tick morning or afternoon first', bothHeld: 'Both halves are held by someone else', nameEmpty: 'Type a desk name first' },
        desksLoadFailed: 'Could not load the desks.', bookingsLoadFailed: 'Could not load the desk bookings.',
        plan: 'Office floor plan', desk: 'Desk', free: 'Free', someone: 'Someone',
        reservations: 'Bookings', none: 'No bookings yet',
        colWho: 'Who', searchWho: 'Search by name', noMatch: 'No bookings match',
        book: 'Book', release: 'Release',
        bookAvailable: 'Book the available days ({{days}})',
        allDay: 'All day', morning: 'Morning', afternoon: 'Afternoon',
        purpose: 'Purpose', flexible: 'Flexible', inflexible: 'Inflexible',
        forVisitor: 'Book for a visitor', visitorName: 'Visitor name',
        booked: 'Booked', released: 'Released', moveDesks: 'Move desks', saveLayout: 'Save layout',
        layoutSaved: 'Layout saved', changePlan: 'Change plan', planReplaced: 'Floor plan replaced',
        planFailed: 'The floor plan image could not be loaded: {{detail}}',
        dragHint: 'Drag desks to reposition',
        // Desk add/rename (673) and change of service (677) — never delete,
        // see office router
        addDesk: 'Add desk', addDeskTitle: 'Add a desk',
        rename: 'Rename', renameDeskTitle: 'Rename "{{desk}}"',
        deskName: 'Desk name',
        deskAdded: 'Desk added', deskRenamed: 'Desk renamed',
        deskNameTooLong: 'Desk names are 50 characters or fewer',
        deskNameDuplicate: 'A desk with this name already exists',
        suspendDesk: 'Take out of service', restoreDesk: 'Return to service',
        suspendTitle: 'Take "{{desk}}" out of service?',
        suspendExplain:
          'Nobody will be able to book it, and it is greyed out on the plan. Nothing is deleted — you can return it to service at any time.',
        suspendKeepsBookings: 'Any bookings it already holds are kept.',
        suspendNoUpcoming: 'It holds no bookings from today onward.',
        suspendUpcoming:
          'Bookings from today onward: {{count}}. Those are kept, but nobody can book it again until it is back in service.',
        deskSuspended: 'Desk taken out of service', deskRestored: 'Desk returned to service',
        // Calendar
        prevMonth: 'Previous month', nextMonth: 'Next month',
        dowMon: 'Mo', dowTue: 'Tu', dowWed: 'We', dowThu: 'Th', dowFri: 'Fr', dowSat: 'Sa', dowSun: 'Su',
        holidayIs: 'Holiday: {{title}}', onLeave: 'You are on leave',
        yourDeskIs: 'Your desk: {{desk}}',
        pickWeekHint: 'Pick as many days as you like within one week. Pick a past day to see its history — booking still only starts from today.',
        pickDaysFirst: 'Pick a day on the calendar', pickDesk: 'Pick a desk on the plan',
        past: 'Past', today: 'today',
        freeOnSelection: '{{free}} of {{total}} desks free',
        // Desk panel
        outOfService: 'Out of service', noKit: 'No equipment recorded',
        halfTaken: 'A half somebody else holds cannot be booked.',
        capReached: 'You booked {{desk}} {{times}} times last week, so it may be closed to you this week.',
        capExempt: 'You booked {{desk}} {{times}} times last week. You are exempt from the weekly cap, so this will not close the desk to you.',
        willReplace: 'Booking this releases {{list}} — one desk per person per day.',
        // Legend
        legendNone: 'Pick days to see availability', legendFree: 'Free every day',
        legendMine: 'Yours, every day', legendMineSome: 'Yours, some days',
        legendInflexible: 'Fixed booking', legendFlexible: 'Flexible, full day',
        legendHalf: 'Half day', legendMixed: 'Mixed',
        legendSelected: 'Selected', legendInactive: 'Out of service',
        legendCapped: 'May be capped for you',
      },
  },
  ru: {
      hotdesk: {
        blocked: { pending: 'Выполняется…', noDays: 'Сначала выберите доступный день в календаре', deskOut: 'Это место не работает', noHalf: 'Сначала отметьте утро или день', bothHeld: 'Обе половины дня заняты другим', nameEmpty: 'Сначала введите название места' },
        desksLoadFailed: 'Не удалось загрузить рабочие места.', bookingsLoadFailed: 'Не удалось загрузить бронирования мест.',
        plan: 'План офиса', desk: 'Рабочее место', free: 'Свободно', someone: 'Кто-то',
        reservations: 'Брони', none: 'Броней пока нет',
        colWho: 'Кто', searchWho: 'Поиск по имени', noMatch: 'Нет совпадений',
        book: 'Забронировать', release: 'Отменить',
        bookAvailable: 'Забронировать свободные дни ({{days}})',
        allDay: 'Весь день', morning: 'Утро', afternoon: 'После обеда',
        purpose: 'Тип', flexible: 'Гибкая', inflexible: 'Фиксированная',
        forVisitor: 'Для посетителя', visitorName: 'Имя посетителя',
        booked: 'Забронировано', released: 'Освобождено', moveDesks: 'Переместить', saveLayout: 'Сохранить',
        layoutSaved: 'Расположение сохранено', changePlan: 'Сменить план', planReplaced: 'План заменён',
        planFailed: 'Не удалось загрузить изображение плана: {{detail}}',
        dragHint: 'Перетащите места',
        // Desk add/rename (673) and change of service (677) — never delete,
        // see office router
        addDesk: 'Добавить место', addDeskTitle: 'Добавить рабочее место',
        rename: 'Переименовать', renameDeskTitle: 'Переименовать «{{desk}}»',
        deskName: 'Название места',
        deskAdded: 'Место добавлено', deskRenamed: 'Место переименовано',
        deskNameTooLong: 'Название должно быть не длиннее 50 символов',
        deskNameDuplicate: 'Место с таким названием уже существует',
        suspendDesk: 'Вывести из эксплуатации', restoreDesk: 'Вернуть в эксплуатацию',
        suspendTitle: 'Вывести «{{desk}}» из эксплуатации?',
        suspendExplain:
          'Никто не сможет его забронировать, на плане оно станет блёклым. Ничего не удаляется — вернуть в эксплуатацию можно в любой момент.',
        suspendKeepsBookings: 'Уже сделанные брони сохраняются.',
        suspendNoUpcoming: 'Броней с сегодняшнего дня нет.',
        suspendUpcoming:
          'Броней с сегодняшнего дня: {{count}}. Они сохраняются, но забронировать снова нельзя до возврата в эксплуатацию.',
        deskSuspended: 'Место выведено из эксплуатации', deskRestored: 'Место возвращено в эксплуатацию',
        // Calendar
        prevMonth: 'Предыдущий месяц', nextMonth: 'Следующий месяц',
        dowMon: 'Пн', dowTue: 'Вт', dowWed: 'Ср', dowThu: 'Чт', dowFri: 'Пт', dowSat: 'Сб', dowSun: 'Вс',
        holidayIs: 'Праздник: {{title}}', onLeave: 'У вас отпуск',
        yourDeskIs: 'Ваше место: {{desk}}',
        pickWeekHint: 'Можно выбрать несколько дней в пределах одной недели. Прошедший день — только для просмотра истории; бронирование доступно с сегодняшнего дня.',
        pickDaysFirst: 'Выберите день в календаре', pickDesk: 'Выберите место на плане',
        past: 'Прошло', today: 'сегодня',
        freeOnSelection: 'Свободно {{free}} из {{total}}',
        // Desk panel
        outOfService: 'Не используется', noKit: 'Оборудование не указано',
        halfTaken: 'Половину дня, занятую другим, забронировать нельзя.',
        capReached: 'Вы бронировали {{desk}} на прошлой неделе {{times}} раз — на этой неделе место может быть недоступно.',
        capExempt: 'Вы бронировали {{desk}} на прошлой неделе {{times}} раз. Вы освобождены от еженедельного лимита, поэтому это место останется доступным.',
        willReplace: 'Бронирование освободит {{list}} — одно место на человека в день.',
        // Legend
        legendNone: 'Выберите дни, чтобы увидеть доступность', legendFree: 'Свободно все дни',
        legendMine: 'Ваше, все дни', legendMineSome: 'Ваше, часть дней',
        legendInflexible: 'Фиксированная бронь', legendFlexible: 'Гибкая, весь день',
        legendHalf: 'Полдня', legendMixed: 'Смешанно',
        legendSelected: 'Выбрано', legendInactive: 'Не используется',
        legendCapped: 'Может быть недоступно для вас',
      },
  },
}
